import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { ExportFormType, Format } from '@connect-services/client/components/export-modal/export-modal.model';
import { FieldInterventionStatusComponent } from '@connect-services/client/components/field-intervention-status/field-intervention-status.component';
import { FieldInterventionExportDto } from '@connect-services/client/sdk/api';
import { CheckboxComponent, CheckboxState } from '@connect-services/src/lib/components/checkbox/checkbox.component';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CheckboxComponent, FieldInterventionStatusComponent, RessourcesModule],
    selector: 'app-export-modal-simple-options',
    templateUrl: './export-modal-simple-options.component.html',
})
export class ExportModalSimpleOptionsComponent {
    public formatList = [Format.ADVANCED_XLSX, Format.XLSX, Format.GEOPACKAGE, Format.SHAPEFILE, Format.KMZ];
    public readonly formGroup = input.required<FormGroup<ExportFormType>>();
    public statusList = [
        FieldInterventionExportDto.StatusEnum.DONE,
        FieldInterventionExportDto.StatusEnum.INVALID,
        FieldInterventionExportDto.StatusEnum.ONGOING,
        FieldInterventionExportDto.StatusEnum.TO_VALIDATE,
        FieldInterventionExportDto.StatusEnum.PLANNED,
    ];

    protected readonly CheckboxState = CheckboxState;
    protected readonly Format = Format;

    public setFormatValue(item: Format, isChecked: boolean): void {
        const controls = this.formGroup().controls;
        this.formGroup().controls.formats.setValue(
            this.updateListItem<Format>(controls.formats.value, item, isChecked),
        );
    }

    public setStatusValue(item: FieldInterventionExportDto.StatusEnum, isChecked: boolean): void {
        const controls = this.formGroup().controls;
        this.formGroup().controls.status.setValue(
            this.updateListItem<FieldInterventionExportDto.StatusEnum>(controls.status.value, item, isChecked),
        );
    }

    private updateListItem<T>(initialList: T[], toggledItem: T, isChecked: boolean): T[] {
        if (!isChecked) {
            return [...initialList, toggledItem];
        }

        return initialList.filter((listItem: T) => listItem !== toggledItem);
    }
}
